const Member = () => null;

export default Member;
